import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Button,
  FormControl,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Switch,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react'
import {
  faAngleDown,
  faAngleUp,
  faCircleInfo,
  faX,
} from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { REPOSITORY } from '../../api/repository/Repository'
import { colors } from '../../utils/theme/styles'
import { useAuthDispatch } from '../../utils/login'
import SvgIcon, { iconNames } from '../SvgIcon/SvgIcon'
import useHover from '../../utils/hooks/useHover'

const Item = ({ text, icon, onCLick }) => {
  const { hover, onBlur, onHover } = useHover()
  const menuTextColor = useMemo(
    () => (hover ? '#F7F7F7' : colors.gray[800]),
    [hover],
  )

  return (
    <MenuItem
      onMouseEnter={onHover}
      onMouseLeave={onBlur}
      onClick={onCLick}
      _hover={{ bgColor: colors.primary.base }}
      bg={colors.gray[50]}
      style={{
        borderTopWidth: 1,
        borderTopColor: colors.gray[200],
        paddingTop: 10,
        paddingBottom: 10,
      }}
    >
      <HStack justifyContent="flex-end" w="100%">
        <Text variant="subtitle2" color={menuTextColor}>
          {text}
        </Text>
        <SvgIcon iconName={icon} color={menuTextColor} />
      </HStack>
    </MenuItem>
  )
}

Item.propTypes = {
  icon: PropTypes.any,
  onCLick: PropTypes.func,
  text: PropTypes.string,
}

export default function Profile({ portal, setPortal, onSalaCuna }) {
  const localData = REPOSITORY.local.company.getUserData()
  const dispatch = useAuthDispatch()
  const { hover, onBlur, onHover } = useHover()
  const navigate = useNavigate()
  const {
    isOpen: openMenu,
    onClose: handleCloseMenu,
    onOpen: handleOpenMenu,
  } = useDisclosure()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const [showInformationPortal, setShowInformationPortal] =
    React.useState(false)

  const data = REPOSITORY.local.company.getUserData()
  const onLoggout = () => {
    REPOSITORY.local.company.eraseData()
    dispatch({ type: 'LOGOUT' })
    navigate('/login')
  }
  const goToContacts = () => {
    navigate('/contacts')
  }
  const goToAlerts = () => {
    navigate('/alerts')
  }

  const goToChangePassword = () => {
    navigate('/change-password')
  }

  const textColor = useMemo(() => {
    if (openMenu) {
      return colors.gray[800]
    }
    return hover ? colors.gray[800] : '#F7F7F7'
  }, [hover, openMenu])
  return (
    <>
      <Modal size="lg" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <VStack p="16px" alignItems="flex-start">
              <HStack>
                <Text variant="body1" fontWeight="bold">
                  Nombre Ejecutiva:
                </Text>
                <Text variant="body1">
                  {data?.oEmpresa?.[0]?.oEjecutivo?.Nombre}
                </Text>
              </HStack>
              <HStack>
                <Text variant="body1" fontWeight="bold">
                  Correo Electrónico:
                </Text>
                <Text variant="body1">
                  {data?.oEmpresa?.[0]?.oEjecutivo?.Email}
                </Text>
              </HStack>
              <HStack>
                <Text variant="body1" fontWeight="bold">
                  Celular:
                </Text>
                <Text variant="body1">
                  {data?.oEmpresa?.[0]?.oEjecutivo?.TelefonoMovil}
                </Text>
              </HStack>
              <HStack>
                <Text variant="body1" fontWeight="bold">
                  Teléfono fijo:
                </Text>
                <Text variant="body1">
                  {data?.oEmpresa?.[0]?.oEjecutivo?.Telefono}
                </Text>
              </HStack>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
      <Menu
        matchWidth={true}
        offset={[0, 0]}
        onOpen={handleOpenMenu}
        onClose={handleCloseMenu}
        backgroundColor="red"
      >
        <MenuButton
          height={'92px'}
          onMouseEnter={onHover}
          onMouseLeave={onBlur}
          borderRadius={0}
          bgColor={openMenu ? '#EEEEEE' : 'transparent'}
          border="transparent"
          _hover={{ bgColor: '#EEEEEE' }}
          as={Button}
        >
          <HStack p="8px" borderRadius="20px">
            <VStack alignItems="flex-end" spacing={0}>
              <Box>
                <Text color={textColor} fontWeight={600} variant="subtitle1">
                  {localData?.user?.sNombreUsuario}
                </Text>
              </Box>
              <Box>
                <Text color={textColor} fontWeight={400} variant="subtitle2">
                  {localData?.user?.sNombreEmpresa}
                </Text>
              </Box>
            </VStack>
            <FontAwesomeIcon
              color={textColor}
              icon={openMenu ? faAngleUp : faAngleDown}
            />
          </HStack>
        </MenuButton>
        <MenuList
          bgColor={colors.gray[50]}
          width={'100%'}
          style={{
            paddingTop: 0,
            borderWidth: 0,
            paddingBottom: 0,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            backgroundColor: '#eeeeee',
            boxShadow: '0 5px 4.5px 1px rgba(64,60,67,.24)',
          }}
        >
          <Item
            icon={iconNames.user}
            text={'Datos de interlocutor'}
            onCLick={goToContacts}
          />
          {localData?.user?.bSalaCunaEmpresa && (
            <Item
              icon={iconNames.cuna}
              text={'Acceder a Sala Cuna'}
              onCLick={onSalaCuna}
            />
          )}
          <Item
            icon={iconNames.keyIcon}
            text={'Cambiar mi clave'}
            onCLick={goToChangePassword}
          />
          <Item
            icon={iconNames.cog}
            text={'Configuraciones'}
            onCLick={goToAlerts}
          />
          <Item
            icon={iconNames.phone}
            text="Contactar Ejecutiva"
            onCLick={onOpen}
          />
          <Item
            icon={iconNames.closeSesion}
            text={'Cerrar sesión'}
            onCLick={onLoggout}
          />
          <div
            style={{
              backgroundColor: '#CBF4C9',
              position: 'relative',
              padding: '16px',
            }}
          >
            <FormControl display="flex" alignItems="center">
              <Text variant="subtitle3" style={{ marginRight: 5 }}>
                Acceso permanente a nuevo portal
              </Text>
              <Switch
                isChecked={portal}
                colorScheme="teal"
                onChange={setPortal}
              />
            </FormControl>
            <Button
              marginTop={3}
              width={'auto'}
              variant="link"
              justifyContent={'flex-start'}
              onClick={() => setShowInformationPortal(!showInformationPortal)}
            >
              <FontAwesomeIcon size="sm" icon={faCircleInfo} color="teal" />
              <Text
                style={{
                  fontSize: 12,
                  marginLeft: 3,
                  textDecorationLine: 'underline',
                }}
              >
                ¿Qué es esto?
              </Text>
            </Button>
            {showInformationPortal && (
              <div
                style={{
                  right: 0,
                  bottom: 0,
                  borderRadius: 5,
                  marginBottom: -80,
                  position: 'absolute',
                  backgroundColor: '#F0F7FF',
                  boxShadow: '0 2px 8px 1px rgba(64,60,67,.24)',
                }}
              >
                <HStack
                  style={{
                    width: 280,
                    height: 70,
                    padding: 10,
                    position: 'relative',
                  }}
                >
                  <HStack height={'100%'} alignItems={'center'}>
                    <Text variant={'subtitle3'}>
                      Activa este switch para ingresar permanentemente al portal
                      con el nuevo diseño.
                    </Text>
                    <Button
                      onClick={() => setShowInformationPortal(false)}
                      variant="ghost"
                      width={'auto'}
                      padding={0}
                      margin={0}
                    >
                      <FontAwesomeIcon size="sm" icon={faX} />
                    </Button>
                  </HStack>
                </HStack>
              </div>
            )}
          </div>
        </MenuList>
      </Menu>
    </>
  )
}

Profile.propTypes = {
  portal: PropTypes.any,
  setPortal: PropTypes.func,
  onSalaCuna: PropTypes.func,
}
